import { useLocalObservable } from 'mobx-react-lite';

import { tvinnaStatusFromJobStatus } from './constants';

export const useTvinnaState = (job) => {
  const state = useLocalObservable(() => ({
    extraInfo: '',
    status: tvinnaStatusFromJobStatus[job.status],
    editExtraInfo(value) {
      state.extraInfo = value;
    },
    editStatus(value) {
      state.status = value;
    },
    get disableSubmit() {
      return state.extraInfo === '';
    },
    get form() {
      return {
        info: state.extraInfo,
        type: state.status,
      };
    },
  }));
  return state;
};
